/*!

=========================================================
* Paper Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";	// reactstrap components

class WiFi extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			password: null
		};
	}

	render() {
		return (
		  <>
			<div className="content">
			  <Row>
				<Col md="12">
					<h1> Login to Beccue WiFi </h1>
				</Col>
			  </Row>

			  <Card>
				<CardHeader>
					  <h5 className="title"> WiFi Password </h5>
				</CardHeader>
				<CardBody>

				  <Row>
					  <Col lg="3">
					  	<Row>
								<Col>
								SSID:
								</Col>
								<Col>
								<b> FBI Van 07b </b>
								</Col>
					  	</Row>
					  	<Row>
								<Col>
								Password:
								</Col>
								<Col>
								<b> 61616161 </b>
								</Col>
					  	</Row>
					  	<Row>
								<Col>
								<img alt="qrcode_wifi" className="pt-4 pb-4" width="375" src="/qrcode-wifi-fbi-van-07b.jpg" />
								</Col>
					  	</Row>
					  </Col>

					  <Col lg="4">
					  </Col>
				  </Row>

				</CardBody>
			  </Card>


			</div>
		  </>
		);
	}
}

export default WiFi;
